"use client"
import { APIProvider } from "@vis.gl/react-google-maps"
import React from "react"

type MapLocaleProviderProps = {
  locale: string
  apiKey: string
  children: React.ReactNode
}

export default function MapLocaleProvider({ locale, apiKey, children }: MapLocaleProviderProps) {
  return (
    <APIProvider language={locale} apiKey={apiKey} libraries={["places"]} version="weekly">
      {children}
    </APIProvider>
  )
}
